<template>
    <div class="container mt-5 mb-5">
        <ais-instant-search :index-name="index" :search-client="searchClient">
            <ais-configure
                :hits-per-page.camel="4"
            />
            <div class="left-panel">
                <!--                <ais-clear-refinements/>-->
                <h2>Location</h2>
                <ais-refinement-list attribute="fields.location"/>
<!--                <h2>Programmes</h2>-->
<!--                <ais-refinement-list attribute="fields.programme"/>-->
<!--                <h2>Products</h2>-->
<!--                <ais-refinement-list attribute="fields.product"/>-->
                <h2>Courses</h2>
                <ais-refinement-list attribute="fields.course"/>

            </div>
            <div class="right-panel">
                <!--            <ais-search-box/>-->
                <ais-hits>
                    <template v-slot:item="{ item }">
                        <AlgoliaResultCard :card="{item}"/>
                    </template>
                </ais-hits>
                <ais-pagination/>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/satellite-min.css';
import AlgoliaResultCard from "./AlgoliaResultCard";

export default {
    name: "AlgoliaSearch",
    components: {
        AlgoliaResultCard
    },
    data() {
        return {
            searchClient: algoliasearch(
                process.env.MIX_ALGOLIA_APP_ID,
                process.env.MIX_ALGOLIA_API_KEY
            ),
            index: process.env.MIX_ALGOLIA_INDEX,
        };
    }
}
</script>

<style>
.ais-InstantSearch {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-gap: 1em;
}

.ais-GeoSearch-input:checked, .ais-RefinementList-item--selected .ais-RefinementList-checkbox {
    background-image: none;
    background-color: black;
}

.ais-Hits {
    margin-top: 2em;
    margin-bottom: 2em;
}

.ais-Hits-item,.ais-InfiniteHits-item  {
    margin:15px;
    box-shadow:0 0 5px 5px rgba(35,38,59,.05),0 1px 3px 0 rgba(35,38,59,.15)
}
.ais-Hits-item:last-of-type, .ais-InfiniteHits-item:last-of-type {
    padding-bottom: 24px;
}

li:last-child {
    padding-bottom: 0;
}
</style>
